import { render } from "./MyAccount.vue?vue&type=template&id=5b13f232&scoped=true&ts=true"
import script from "./MyAccount.vue?vue&type=script&lang=ts"
export * from "./MyAccount.vue?vue&type=script&lang=ts"

import "./MyAccount.vue?vue&type=style&index=0&id=5b13f232&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b13f232"]])

export default __exports__